var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex-center header-selector i-menu-expanded",on:{"click":function($event){_vm.$emit('update:isOpen', !_vm.isOpen)}}})}
var staticRenderFns = []

export { render, staticRenderFns }